// extracted by mini-css-extract-plugin
export var collapsedSummary = "_oa-0";